import { ActionTypes, Action as TruckAction } from './trucksActions';
import { Reducer } from 'redux';
import { UploadState } from '../models/document';
import { Action as DocumentAction, ActionType as DocumentActionType } from '../store/actions/document';
import { TruckState } from '../store/state/truck';
import { ActionType } from '../store/actions/truck';
import { Action } from '../store/actions';

const initialState: TruckState = {
  selectedDate: undefined,
  isLoading: false,
  all: {},
};

const updateDocumentState = (
  state: TruckState,
  truckId: string,
  documentId: string,
  manualUploadState: UploadState,
): TruckState => {
  const docs = state.all[truckId].manifest!.documents
    .map(document =>
      document.id === documentId ? { ...document, manualUploadState } : document,
    );

  return {
    ...state,
    all: {
      ...state.all,
      [truckId]: {
        ...state.all[truckId],
        manifest: {
          ...state.all[truckId].manifest!,
          documents: docs,
        },
      },
    },
  };
};

const trucksReducer: Reducer<TruckState, Action | TruckAction | DocumentAction> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_TRUCKS_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case ActionType.GET_TRUCKS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    case ActionType.GET_TRUCKS_SUCCESS:
      const all: TruckState['all'] = {};
      action.data.forEach(truck =>
        all[truck.id] = {
          ...state.all[truck.id],
          ...truck,
        },
      );
      return {
        ...state,
        all,
        isLoading: false,
      };

    case ActionType.CREATE_TRUCK_SUCCESS:
      return {
        ...state,
        all: {
          ...state.all,
          [action.data.id]: action.data,
        },
      };

    case ActionType.CREATE_TRUCK_FAILURE:
      return state;

    case ActionType.DELETE_TRUCK_SUCCESS:
      const { [action.data.id]: deletedTruck, ...updatedTrucks } = state.all;
      return {
        ...state,
        all: updatedTrucks,
      };

    case ActionType.DELETE_TRUCK_FAILURE:
      return state;

    case ActionType.LOAD_SHIPMENT_GROUP_SUCCESS:
    case ActionType.LOAD_TRUCK_SUCCESS:
      return {
        ...state,
        all: {
          ...state.all,
          [action.data.truck.id]: {
            ...state.all[action.data.truck.id],
            ...action.data.truck,
          },
        },
      };

    case ActionType.GENERATE_MANIFEST_SUCCESS:
    case ActionType.PATCH_TRUCK_SUCCESS:
      return {
        ...state,
        all: {
          ...state.all,
          [action.data.id]: {
            ...state.all[action.data.id],
            ...action.data,
          },
        },
      };

    case DocumentActionType.UPLOAD_DOCUMENT_REQUEST:
      return updateDocumentState(state, action.data.truck.id, action.data.document.id, UploadState.UPLOADING);
    case DocumentActionType.UPLOAD_DOCUMENT_SUCCESS:
      return updateDocumentState(state, action.data.truck.id, action.data.document.id, UploadState.SUCCESS);
    case DocumentActionType.UPLOAD_DOCUMENT_FAILURE:
      return updateDocumentState(state, action.data.truck.id, action.data.document.id, UploadState.FAILURE);

    case ActionTypes.SET_SELECTED_DATE:
      return {
        ...state,
        selectedDate: action.selectedDate,
      };

    default:
      return state;
  }
};

export default trucksReducer;
